/** The CRM module's console-local paths. Slug `donors`, label `CRM`, and URL `/crm` stay decoupled. */
export const CRM_MODULE_ROUTES = {
  contacts: '/crm',
  donor: (donorId: string) => `/crm/donors/${encodeURIComponent(donorId)}`,
  donorPattern: '/crm/donors/$donorId',
  // CRM-5: the segment list, a new segment, and one segment.
  segments: '/crm/segments',
  newSegment: '/crm/segments/new',
  segment: (segmentId: string) => `/crm/segments/${encodeURIComponent(segmentId)}`,
  segmentPattern: '/crm/segments/$segmentId',
  /** CPB-WEB8: "Bring your contacts", the contact import. */
  import: '/crm/import',
} as const;
